import { useRef as i, useCallback as c } from "react";
function o() {
  const r = i([]), u = c(
    (e, t = !0) => {
      t && !r.current.includes(e) && (r.current = [...r.current, e]), !t && r.current.includes(e) && (r.current = r.current.filter(
        (n) => e !== n
      ));
    },
    []
  );
  return {
    getAriaControls: () => r.current,
    toggleAriaControls: u
  };
}
export {
  o as usePopoverAria
};
